import { Component } from 'react';
import { withRouter } from 'react-router';
import { string, node, shape } from 'prop-types';

const propTypes = {
  children: node.isRequired,
  location: shape({ pathname: string }).isRequired,
};

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;

    if (location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ScrollToTop.propTypes = propTypes;

export default withRouter(ScrollToTop);
